import { i18n } from '@/plugins/i18n'

export const deviceTypeList = {
    GPRS: 'GPRS',
    MPOS: 'MPOS',
    HDLC: 'HDLC',
    LAN: 'LAN',
    HDLC_LAN: 'HDLC/LAN',
    WIFI_GPRS: 'wifi/GPRS',
    AndroidPos: 'AndroidPos',
    WIFI: 'Wifi',
    Dialup:'Dialup'
}

export const deviceTypeStr = {
    POS: i18n.t('pos.posDeviceTypes.pos'),
    INTERNET_GATEWAY: i18n.t('pos.posDeviceTypes.wireless_pos'),
    MOBILE_GATEWAY: i18n.t('pos.posDeviceTypes.wireless_pos'),
    WIRELESS_POS: i18n.t('pos.posDeviceTypes.wireless_pos'),

    get(deviceType) {
        let device_type_str = null;
        Object.keys(deviceTypeList).forEach(function (item) {
            if(novinDeviceTypeList[item] === deviceType) {
                device_type_str = deviceTypeStr[item]
            }
        })

        return device_type_str
    }
}